import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@devinforius/super-compos-17';
import * as moment from 'moment';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DataService } from 'src/app/core/services/data.service';
import { MeetingAdvancedSearch } from 'src/app/modules/private/pages/meetings/interfaces';
import { Global_Class } from 'src/app/shared/models/global';

@Component({
  selector: 'app-meeting-search',
  templateUrl: './meeting-search.component.html',
  styleUrls: ['./meeting-search.component.scss'],
})
export class MeetingSearchComponent implements OnInit {
  public form: UntypedFormGroup = new UntypedFormGroup({
    Description: new UntypedFormControl(null),
    LieuxIds: new UntypedFormControl(null),
    Date: new UntypedFormControl(null),
    DateDebut: new UntypedFormControl(null),
    DateFin: new UntypedFormControl(null),
    TypeSeanceIds: new UntypedFormControl(null),
    IncludeDeleted: new UntypedFormControl(null),
    statutId: new UntypedFormControl(null),
    Verrouille: new UntypedFormControl(null),
    Cloture: new UntypedFormControl(null),
    Ouvert: new UntypedFormControl(null),
    countInclus: new UntypedFormControl(true),
  });
  public globalElements: Global_Class = null;
  public seanceStatus = [];
  dataReceived: any;
  @ViewChild('meetingSearchInput') meetingSearchInput: ElementRef;
  constructor(
    public dataService: DataService,
    public dialogRef: DynamicDialogRef,
    public translate: TranslateService,
    public config: DynamicDialogConfig
  ) {}

  ngOnInit(): void {
    this.dataReceived = this.config.data;
    this.dataService.getGlobalElements.subscribe((res: any) => {
      this.globalElements = new Global_Class(res);
    });

    if (this.dataService.advancedSearchMeeting) {
      const datas = this.dataService.advancedSearchMeeting;
      delete datas.PageNumber;
      delete datas.SortOrder;
      datas.DateDebut ? (datas.DateDebut = moment(datas.DateDebut, 'YYYY-MM-DD').toDate()) : null;
      datas.Date ? (datas.Date = moment(datas.Date, 'YYYY-MM-DD').toDate()) : null;
      datas.DateFin ? (datas.DateFin = moment(datas.DateFin, 'YYYY-MM-DD').toDate()) : null;
      datas.statutId = [];
      // Fonction auxiliaire pour ajouter des éléments sans doublons
      const addUnique = (array, item) => {
        if (!array.includes(item)) {
          array.push(item);
        }
      };

      if (this.dataReceived) {
        if (this.dataReceived === 'open') {
          addUnique(datas.statutId, 'open');
        }
        if (this.dataReceived === 'pending') {
          addUnique(datas.statutId, 'pending');
        }
        if (this.dataReceived === 'closed') {
          addUnique(datas.statutId, 'closed');
        }
      }

      if (datas.Ouvert) {
        addUnique(datas.statutId, 'open');
      }
      if (datas.Verrouille) {
        addUnique(datas.statutId, 'pending');
      }
      if (datas.Cloture) {
        addUnique(datas.statutId, 'closed');
      }

      this.form.patchValue(this.dataService.advancedSearchMeeting);
    }

    this.seanceStatus.push(
      { label: this.translate.translate('global.open'), value: 'open' },
      { label: this.translate.translate('global.pending'), value: 'pending' },
      { label: this.translate.translate('global.closed'), value: 'closed' }
    );
    if (!this.dataService.advancedSearchMeeting) {
      this.form.get('statutId').setValue([this.dataReceived]);
    }
  }

  ngAfterViewInit() {
    this.meetingSearchInput.nativeElement.focus();
  }

  onCloseDialog() {
    const statutId = [this.form.value.statutId];

    this.resetFormStatusesState();

    if (statutId && statutId.length > 0) {
      statutId[0].map((x) => {
        if (x === 'open') {
          this.form.patchValue({ Ouvert: true });
        }
        if (x === 'pending') {
          this.form.patchValue({ Verrouille: true });
        }
        if (x === 'closed') {
          this.form.patchValue({ Cloture: true });
        }
      });
    }

    this.form.patchValue({ statutId: null }); //on remet a null pour le removeEmpty
    this.dataService.advancedSearchEnabled = true;
    this.dialogRef.close(this.form.value as MeetingAdvancedSearch);
    this.reset();
  }

  private resetFormStatusesState(): void {
    this.form.patchValue({
      Ouvert: null,
      Verrouille: null,
      Cloture: null,
    });
  }

  reset() {
    this.form.reset();
  }
}
